import PropTypes from "prop-types";

import { fleetManagementSections, strCode } from "../../../consts";
import { t } from "../../../services";
import { withSection } from "../../../hoc";

import { FlexContainers, Heading5, RefreshButton, WrapperContainer } from "../../../components";
import { FleetManagementControlsWrapper } from "./styled";

const FleetManagementControls = ({
  activePage,
  devicesLoading,
  fwuCampaignsLoading,
  notificationsLoading,
  fwuVersionsLoading,

  onRefresh = () => {}
}) => {
  return (
    <WrapperContainer Container={FleetManagementControlsWrapper}>
      <WrapperContainer Container={FlexContainers.FlexRowStart} width={"100%"} gap={16}>
        <Heading5>{t(strCode.FLEET_MANAGEMENT_NAV_BTN)}</Heading5>

        <RefreshButton
          isLoading={
            activePage === fleetManagementSections.DEVICES
              ? devicesLoading
              : activePage === fleetManagementSections.FWU_CAMPAIGNS
              ? fwuCampaignsLoading || notificationsLoading || fwuVersionsLoading
              : fwuVersionsLoading
          }
          handleRefresh={onRefresh}
        />
      </WrapperContainer>
    </WrapperContainer>
  );
};

FleetManagementControls.propTypes = {
  activePage: PropTypes.string.isRequired,
  devicesLoading: PropTypes.bool.isRequired,
  fwuCampaignsLoading: PropTypes.bool.isRequired,
  notificationsLoading: PropTypes.bool.isRequired,
  fwuVersionsLoading: PropTypes.bool.isRequired,
  hasMaxActiveFwuCampaigns: PropTypes.bool.isRequired,

  deviceSearchValue: PropTypes.string.isRequired,
  firmwareSearchValue: PropTypes.string.isRequired,
  fwuCampaignSearchValue: PropTypes.string.isRequired,
  selectedDevice: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    value: PropTypes.string.isRequired
  }).isRequired,
  firmwareDeviceFilter: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    value: PropTypes.string.isRequired
  }).isRequired,
  deviceOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      value: PropTypes.string.isRequired
    }).isRequired
  ),

  marketOption: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }).isRequired,

  setDeviceSearchValue: PropTypes.func.isRequired,
  setSelectedDevice: PropTypes.func.isRequired,
  setMarketOption: PropTypes.func.isRequired,
  setFirmwareSearchValue: PropTypes.func.isRequired,
  setFirmwareDeviceFilter: PropTypes.func.isRequired,
  setFwuCampaignSearchValue: PropTypes.func.isRequired,

  onRefresh: PropTypes.func.isRequired,
  onCreateDevice: PropTypes.func.isRequired,
  onCreateBatch: PropTypes.func.isRequired,
  onCreateFwuCampaign: PropTypes.func.isRequired,
  onCreateFwuVersion: PropTypes.func.isRequired
};

export default withSection(FleetManagementControls);
